import React, { useState, useEffect, useMemo } from 'react';
import '../../../../../../src/index.css'; 
import ReusableTable from '../../reusableTable';

const TablePrevGuestUser = ({
  recordsPerPage,
  currentPage,
  setCurrentPage,
  excelData,
  totalRecords,
  onDeleteUser
}) => {

  const [data, setData] = useState([]);

  useEffect(() => {

    if (excelData && excelData.length > 0) {
      const formattedData = excelData.map((item) => ({
        id: item.id,
        user_code: item.user_code,
        fullName: item.fullName,
        email: item.email,
        contact_number: item.contact_number,
        personnel_division: item.personnel_division,
        position: item.position,
        hierarchichal_manage: item.hierarchichal_manage,
        functional_area: item.functional_area,
      }));


      setData(formattedData);
    } else {
      setData([
      ]);
    }
  }, [excelData]);



  /**COLUMNAS */
  const columns = useMemo(
    () => [
      {
        Header: '#',
        accessor: 'id',
        style: { width: '50px' },
        Cell: ({ row }) => (row.index + 1) + (currentPage - 1) * recordsPerPage
      },
      { Header: 'Código', accessor: 'user_code', style: { width: '160px' } },
      { Header: 'Nombre y apellido', accessor: 'fullName', style: { width: '290px' } },
      { Header: 'División de personal', accessor: 'personnel_division', style: { width: '200px' } },
      { Header: 'Posición', accessor: 'position', style: { width: '140px' } },
      { Header: 'Correo', accessor: 'email', style: { width: '280px' } },
      { Header: 'Gerencia jerárquica', accessor: 'hierarchichal_manage', style: { width: '240px' } },
      { Header: 'Área funcional', accessor: 'functional_area', style: { width: '240px' } },
      {
        Header: '',
        accessor: 'delete',
        style: { width: '127px' },
        Cell: ({row}) => (
          <div className="flex items-center justify-center">
            <button 
              onClick={() => onDeleteUser(row.original.id)}
              className="p-2 flex justify-center items-center bg-[#EFEEF7] rounded-[4px] border-[#D9D9D9] border-[1px] w-[49px] h-[37px]">
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12.7008 3.10083L12.945 4.79167H16.25C16.4158 4.79167 16.5747 4.85751 16.6919 4.97472C16.8092 5.09193 16.875 5.25091 16.875 5.41667C16.875 5.58243 16.8092 5.7414 16.6919 5.85861C16.5747 5.97582 16.4158 6.04167 16.25 6.04167H15.6092L14.8817 14.5292C14.8375 15.0458 14.8017 15.4708 14.7442 15.8142C14.6858 16.1717 14.5967 16.4917 14.4225 16.7883C14.149 17.2543 13.7424 17.6278 13.255 17.8608C12.945 18.0083 12.6183 18.0692 12.2567 18.0975C11.9092 18.125 11.4833 18.125 10.965 18.125H9.035C8.51667 18.125 8.09083 18.125 7.74333 18.0975C7.38167 18.0692 7.055 18.0083 6.745 17.8608C6.25757 17.6278 5.85098 17.2543 5.5775 16.7883C5.4025 16.4917 5.315 16.1717 5.25583 15.8142C5.19833 15.47 5.1625 15.0458 5.11833 14.5292L4.39083 6.04167H3.75C3.58424 6.04167 3.42527 5.97582 3.30806 5.85861C3.19085 5.7414 3.125 5.58243 3.125 5.41667C3.125 5.25091 3.19085 5.09193 3.30806 4.97472C3.42527 4.85751 3.58424 4.79167 3.75 4.79167H7.055L7.29917 3.10083L7.30833 3.05C7.46 2.39167 8.025 1.875 8.73333 1.875H11.2667C11.975 1.875 12.54 2.39167 12.6917 3.05L12.7008 3.10083ZM8.3175 4.79167H11.6817L11.4683 3.31167C11.4283 3.1725 11.3267 3.125 11.2658 3.125H8.73417C8.67333 3.125 8.57167 3.1725 8.53167 3.31167L8.3175 4.79167ZM9.375 8.75C9.375 8.58424 9.30915 8.42527 9.19194 8.30806C9.07473 8.19085 8.91576 8.125 8.75 8.125C8.58424 8.125 8.42527 8.19085 8.30806 8.30806C8.19085 8.42527 8.125 8.58424 8.125 8.75V12.9167C8.125 13.0824 8.19085 13.2414 8.30806 13.3586C8.42527 13.4758 8.58424 13.5417 8.75 13.5417C8.91576 13.5417 9.07473 13.4758 9.19194 13.3586C9.30915 13.2414 9.375 13.0824 9.375 12.9167V8.75ZM11.875 8.75C11.875 8.58424 11.8092 8.42527 11.6919 8.30806C11.5747 8.19085 11.4158 8.125 11.25 8.125C11.0842 8.125 10.9253 8.19085 10.8081 8.30806C10.6908 8.42527 10.625 8.58424 10.625 8.75V12.9167C10.625 13.0824 10.6908 13.2414 10.8081 13.3586C10.9253 13.4758 11.0842 13.5417 11.25 13.5417C11.4158 13.5417 11.5747 13.4758 11.6919 13.3586C11.8092 13.2414 11.875 13.0824 11.875 12.9167V8.75Z" fill="black"/>
            </svg>
            </button>
          </div>
        )
      },
    ],
    [onDeleteUser]
  );

  return (
    <ReusableTable
      columns={columns}
      data={data}
      currentPage={currentPage}
      setCurrentPage={setCurrentPage}
      recordsPerPage={recordsPerPage}
      totalRecords={totalRecords}
      loading={false}
      error={null}
    />
  );
};

export default TablePrevGuestUser;